import Vue from 'vue';

const success = ({ data }, resolve) => {
  resolve(data);
};

const failed = () => {};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/orders/counts')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/counts.js